import { formatPhoneNumber } from '../../../../../../utils';

interface IApplicationInformationDetailsProps {
  applicationInformation: {
    city: string;
    cityEmployee: string;
    disabled: string;
    dob: string;
    gender: string;
    homePhone?: string;
    lastFourSocial: string;
    maritalStatus: string;
    name: string;
    otherPhone: string;
    races?: string[];
    state: string;
    streetAddress: string;
    workPhone: string;
    zipCode: string;
  };
}
export default function ApplicationInformationDetails({
  applicationInformation,
}: IApplicationInformationDetailsProps) {
  return (
    <>
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="py-5">
            <div className="px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal">
              <h2
                id="applicant-information-title"
                className="m-0 text-lg leading-6 font-medium text-primaryColor-normal">
                Application Information
              </h2>
            </div>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6">
            <div className="space-y-6">
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Name</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {applicationInformation?.name}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Address</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {applicationInformation?.streetAddress},{' '}
                    {applicationInformation?.city},{' '}
                    {applicationInformation?.state},{' '}
                    {applicationInformation?.zipCode}
                  </dd>
                </div>

                {/* <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">City</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    +1 {formatPhoneNumber(applicationInformation?.city)}
                  </dd>
                </div> */}
              </dl>
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Work Phone
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    +1 {formatPhoneNumber(applicationInformation?.workPhone)}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Cell / Other Phone
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    +1 {formatPhoneNumber(applicationInformation?.otherPhone)}
                  </dd>
                </div>
              </dl>
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Home Phone
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {applicationInformation?.homePhone
                      ? `+1 ${formatPhoneNumber(
                          applicationInformation?.workPhone
                        )}`
                      : 'Not Available'}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Date of Birth
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {applicationInformation?.dob}
                  </dd>
                </div>
              </dl>
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Last four of Social
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {applicationInformation?.lastFourSocial}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Gender</dt>
                  <dd className="mt-1 text-sm text-gray-900 capitalize">
                    {applicationInformation?.gender}
                  </dd>
                </div>
              </dl>
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Marital Status
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {applicationInformation?.maritalStatus}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    City Employee
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 capitalize">
                    {applicationInformation?.cityEmployee}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Races</dt>
                  <dd className="mt-1 text-sm text-gray-900 capitalize">
                    {applicationInformation?.races
                      ? applicationInformation?.races.map((r) => <li>{r}</li>)
                      : 'Not Found'}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
